module.exports = __webpack_public_path__ + "components/country-flag/static/ad-8df8e0656fcba32fed369a6aca11c1fe.svg";